import React from 'react';
import { Color, setColor } from 'src/styles/colors';
import styled from 'styled-components';

const ORIENTATION_MAP = {
  up: 'rotate(0deg)',
  down: 'rotate(180deg)',
  left: 'rotate(-90deg)',
  right: 'rotate(90deg)',
};

type SvgContainerProps = {
  orientation?: keyof typeof ORIENTATION_MAP;
  width?: number;
  color?: Color;
};

const SvgContainer = styled.svg<SvgContainerProps>`
  transform: ${({ orientation }) => ORIENTATION_MAP[orientation]};
  transition: transform 0.3s ease-in-out;
`;

const Chevron = ({ width = 25, orientation = 'up', color = 'white' }: SvgContainerProps): JSX.Element => {
  return (
    <SvgContainer
      className='chevron'
      orientation={orientation}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        fill={setColor(color)}
        d='M7.91 15.41L12.5 10.83L17.09 15.41L18.5 14L12.5 8L6.5 14L7.91 15.41Z'
      />
    </SvgContainer>
  );
};

export default Chevron;
